import OnboardingLayoutHeader from './OnboardingLayoutHeader';

export default OnboardingLayoutHeader;
